export default {"src":"/_next/static/media/qrcode-circle-gray.24a014f9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};